import { render, staticRenderFns } from "./SettingCard.vue?vue&type=template&id=772a9f36&scoped=true&"
import script from "./SettingCard.vue?vue&type=script&lang=js&"
export * from "./SettingCard.vue?vue&type=script&lang=js&"
import style0 from "./SettingCard.vue?vue&type=style&index=0&id=772a9f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a9f36",
  null
  
)

export default component.exports